<template>
  <span style="cursor: pointer">
    <span @click="getPermission()"><slot></slot></span>
    <v-snackbar v-model="copySnackbar" bottom right :timeout="3000" color="success">
      {{ $t('Copied') }}!
    </v-snackbar>
  </span>
</template>

<script>
export default {
  name: 'CopyButton',
  props: {
    text: {
      required: true
    }
  },
  data() {
    return {
      copySnackbar: false
    }
  },
  methods: {
    async copyText() {
      try {
        await navigator.clipboard.writeText(this.text)
        this.copySnackbar = true
      } catch (error) {
        console.error(error)
      }
    },
    getPermission() {
      navigator.permissions.query({ name: 'clipboard-write' }).then((result) => {
        if (result.state === 'granted' || result.state === 'prompt') {
          this.copyText()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/elements/CopyButton.vue